import { SeoEnricherSection } from '../utils/seoEnricherPreview';

export const CITY_TEMPO_TRAVELLER_SEO_ENRICHED_SECTIONS: SeoEnricherSection[] = [
  {
    intent: 'tempo_traveller',
    title: 'Tempo Traveller Booking in ${city_name}',
    subtitle: 'A convenient option for group travel from ${city_name}',
    content:
      '<p>Planning a group journey from ${city_name}? A Tempo Traveller is a suitable option for larger groups travelling together with family, friends, or colleagues. It can accommodate up to 12 passengers and up to 8 bags, providing ample seating and luggage space for group travel.</p><table><thead><tr><th>Vehicle</th><th>Seat Capacity</th><th>Fuel Type</th><th>Luggage Capacity</th></tr></thead><tbody><tr><td>Tempo Traveller</td><td>Up to 12 passengers</td><td>Diesel</td><td>Up to 8 bags</td></tr></tbody></table><p>You can consider your group size and luggage requirements while selecting a Tempo Traveller for your journey from ${city_name}.</p>',
    faqs: [
      {
        question:
          'How many passengers can travel in a Tempo Traveller from ${city_name}?',
        answer:
          'A Tempo Traveller can accommodate up to 12 passengers, making it suitable for larger groups travelling from ${city_name}.'
      },
      {
        question: 'How much luggage can a Tempo Traveller carry?',
        answer:
          'A Tempo Traveller can accommodate up to 8 bags, making it suitable for groups travelling with substantial luggage.'
      },
      {
        question:
          'Is a Tempo Traveller suitable for group travel from ${city_name}?',
        answer:
          'Yes, a Tempo Traveller is suitable for larger groups travelling with family, friends, or colleagues from ${city_name}, with seating for up to 12 passengers and space for up to 8 bags.'
      }
    ]
  },
  {
    intent: 'fare_inclusions',
    title: 'What’s Included in Your Tempo Traveller Fare',
    subtitle:
      'Understand the fare components for your journey from ${city_name}',
    content:
      '<p>When you book your journey from ${city_name} with MakeMyTrip, several components are included in your fare, helping you understand what you are paying for.</p><table><thead><tr><th>Fare Component</th><th>Details</th></tr></thead><tbody><tr><td>Toll Charges</td><td>Applicable toll charges for your route are included in the fare for one-way and round trips.</td></tr><tr><td>Parking Fees</td><td>Parking fees at the pickup and drop-off locations are included in the fare.</td></tr><tr><td>Driver Allowance</td><td>Driver allowance for meals and accommodation is applicable for round trips.</td></tr></tbody></table>',
    faqs: [
      {
        question: 'Are toll charges included when booking from ${city_name}?',
        answer:
          'Yes, applicable toll charges are included in the fare for one-way and round trips with MakeMyTrip.'
      },
      {
        question:
          'Are parking charges included in my booking from ${city_name}?',
        answer:
          'Yes, parking fees at the pickup and drop-off locations are included in the fare.'
      },
      {
        question:
          "Do I need to pay separately for the driver's food and accommodation?",
        answer:
          'Driver allowance for food and accommodation is included in the fare, so no extra payment is required for these arrangements.'
      }
    ]
  },
  {
    intent: 'waiting_time_policy',
    title: 'Waiting Time Policies',
    subtitle:
      'Understand waiting time policies for your booking from ${city_name}',
    content:
      '<p>Understanding the applicable waiting time policies can help you plan your journey from ${city_name}. MakeMyTrip provides a complimentary waiting window at pickup, with the applicable duration depending on the selected vehicle category.</p><table><thead><tr><th>Policy Area</th><th>Details</th></tr></thead><tbody><tr><td>Free Waiting at Pickup</td><td>A complimentary waiting window of 30 to 45 minutes is provided at pickup, depending on the selected vehicle category.</td></tr><tr><td>Charges After Grace Period</td><td>Beyond the free waiting period, applicable waiting charges accrue in 30 to 60 minute slabs based on vehicle type, driver availability, and vendor fare rules.</td></tr><tr><td>En-route Stops</td><td>Waiting at en-route stops does not incur additional charges.</td></tr></tbody></table><p>Prolonged pickup delays exceeding the maximum allowed waiting limit may result in driver release and trip cancellation without refund.</p>',
    faqs: [
      {
        question:
          'Will my vehicle wait if I am delayed at pickup in ${city_name}?',
        answer:
          'MakeMyTrip provides a complimentary waiting window of 30 to 45 minutes at pickup, depending on the selected vehicle category.'
      },
      {
        question: 'Are there additional charges if I am late for pickup?',
        answer:
          'Waiting charges may apply beyond the free waiting period based on vehicle type, driver availability, and vendor fare rules.'
      },
      {
        question: 'Are there waiting charges at en-route stops?',
        answer: 'Waiting at en-route stops does not incur additional charges.'
      }
    ]
  },
  {
    intent: 'driver_quality',
    title: 'Driver Quality and Professionalism',
    subtitle:
      'Know what to expect from your driver during your journey from ${city_name}',
    content:
      '<p>When you book with MakeMyTrip, your driver and vehicle details will be shared up to 30 minutes before your scheduled departure time, allowing you to verify the information before boarding.</p><table><thead><tr><th>Policy Area</th><th>Details</th></tr></thead><tbody><tr><td>Driver Details</td><td>Driver and vehicle details are shared up to 30 minutes before the scheduled departure.</td></tr><tr><td>Driver Verification</td><td>Verify the vehicle details before boarding. If a different vehicle or driver arrives, do not board and contact customer support.</td></tr><tr><td>Language Preference</td><td>While booking, you can request a driver who speaks your preferred language for better communication.</td></tr></tbody></table>',
    faqs: [
      {
        question:
          'When will I receive the driver details for my booking from ${city_name}?',
        answer:
          'Your driver and vehicle details will be shared up to 30 minutes before your scheduled departure time.'
      },
      {
        question: 'What should I do if a different vehicle or driver arrives?',
        answer:
          'Verify your vehicle details before boarding. If a different vehicle or driver arrives, do not board and contact MakeMyTrip customer support immediately.'
      },
      {
        question: 'Can I request a driver who speaks my preferred language?',
        answer:
          'Yes, you can request a driver who speaks your preferred language while booking.'
      }
    ]
  },
  {
    intent: 'night_travel',
    title: 'Night Travel Charges and Policies',
    subtitle: 'Understand night travel charges for journeys from ${city_name}',
    content:
      '<p>If you are planning to travel at night from ${city_name}, additional night charges may apply depending on your trip type. Night charges are applicable when the vehicle is used between 10:00 PM and 6:00 AM.</p><table><thead><tr><th>Policy Area</th><th>Details</th></tr></thead><tbody><tr><td>Night Charge Timing</td><td>Applicable from 10:00 PM to 6:00 AM</td></tr><tr><td>Round Trip & Multi-City</td><td>Additional night charges may apply.</td></tr><tr><td>One-Way</td><td>Night charges are included in the fare.</td></tr></tbody></table><p>For specific rates and applicable charges, check the final fare details during the booking process.</p>',
    faqs: [
      {
        question: 'Are there night charges when travelling from ${city_name}?',
        answer:
          'Night charges apply when the vehicle is used between 10:00 PM and 6:00 AM.'
      },
      {
        question: 'Are night charges included for one-way bookings?',
        answer:
          'Yes, night charges are included in the overall fare for one-way trips.'
      },
      {
        question: 'Are there additional night charges for round-trip bookings?',
        answer:
          'For round trips, additional night charges may apply and are paid directly to the driver.'
      }
    ]
  },
  {
    intent: 'booking_modification',
    title: 'Modifying Your Booking',
    subtitle: 'Know your options if your travel plans from ${city_name} change',
    content:
      '<p>Travel plans can change, and MakeMyTrip provides flexibility to modify your booking details. You can request free modifications to travel dates, pickup or drop locations, and vehicle types up to one hour before your scheduled departure.</p>',
    faqs: [
      {
        question: 'Can I modify my booking from ${city_name}?',
        answer:
          'Yes, you can request free modifications to your travel dates, pickup or drop locations, and vehicle type up to one hour before your scheduled departure.'
      },
      {
        question: 'Can I change my vehicle type after booking?',
        answer:
          'Yes, vehicle type is one of the booking details that can be requested for modification up to one hour before departure.'
      }
    ]
  }
];
